/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { useState } from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { useTheme } from "@material-ui/core/styles";

import { Divider, Hidden, Fab, Grid, TextField } from "@material-ui/core";
import { Share, Security } from "@material-ui/icons";

import Button from "components/CustomButtons/Button.jsx";

import { backButton } from "components/Form/FormField";
import { buttonYT } from "client/views/Account/WelcomePage";
import { renderSharePopover } from "client/views/CoursesPage/CourseActions";
import { SurveyDialog } from "./SurveyDialg";

import {
  sSupportUs,
  sSupUs1,
  sSupUs2,
  sSupUs3,
  sGiveFeedback,
  sShare,
  sSecPay,
  sChgDonate,
} from "assets/jss/views/ResStrings";
import { idSurvTake } from "assets/jss/views/ElementIDs";

import supPageStyle from "assets/jss/views/supportUs/supPageStyle";
// import { PayPalButton } from "../Shopping/Payment/PayPalButton";
const styles = createStyles(supPageStyle as any);

interface Props extends WithStyles<typeof styles> {
  classes: any;
  match: any;
  history: any;
}

const SupportUsPageBase: React.FC<Props> = ({
  classes,
  match,
  history,
}: Props) => {
  const inputTextId = "ac_input_text1";
  const { page } = match.params;
  const [anchorEl, setAnchorEl] = useState<any>(null);

  const [showDonate, setShowDonate] = useState(false);
  const [donateAmount, setDonateAmount] = useState(0);
  const [donateChoice, setDonateChoice] = useState(-1);

  const handleShare = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    open: Boolean,
  ) => {
    event.preventDefault();
    setAnchorEl(open ? event.currentTarget : null);
  };
  const btnIconStyle = {
    width: "56px",
    height: "28px",
    margin: "-0.5rem 0",
  };

  const buttonShare = () => {
    const handler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
      handleShare(e, true);

    return (
      <>
        <Hidden xsDown>
          <Button color="success" round size="lg" onClick={handler}>
            <i className="fas fa-share-alt" style={btnIconStyle}></i>
            {sShare}
          </Button>
        </Hidden>
        <Hidden smUp>
          <Fab color="secondary" onClick={handler}>
            <Share fontSize="large" />
          </Fab>
        </Hidden>
      </>
    );
  };

  const donateOptions = () => {
    const opts: { amount: number; img?: string }[] = [
      { amount: 5, img: require("assets/img/coffee-cup.png") },
      { amount: 10, img: require("assets/img/brkfst.png") },
      { amount: 25, img: require("assets/img/donuts.png") },
      { amount: 0 },
    ];
    return (
      <>
        <h5>{sSupUs3}</h5>
        <Grid container className={classes.donateOpts}>
          {opts.map((opt, idx) => (
            <Grid item xs={3} key={idx}>
              <div
                className={
                  idx === donateChoice
                    ? classes.donateOptSel
                    : classes.donateOptUn
                }
                onClick={() => {
                  setDonateChoice(idx);
                  setDonateAmount(opt.amount);
                }}>
                {opt.amount ? (
                  <>
                    <img className={classes.donateImg} src={opt.img} />
                    <span
                      className={classes.donateNum}
                      style={{ position: "absolute" }}>
                      ${opt.amount}
                    </span>
                  </>
                ) : (
                  <div
                    className={classes.donateNum}
                    style={{ display: "flex", alignItems: "center" }}>
                    $&nbsp;
                    <TextField
                      size="medium"
                      InputProps={{ classes: { input: classes.donateNum } }}
                      type="number"
                      margin="dense"
                      id={inputTextId}
                      onChange={(e) =>
                        setDonateAmount(
                          Number(parseFloat(e.target.value).toFixed(2)),
                        )
                      }
                    />
                  </div>
                )}
              </div>
            </Grid>
          ))}
        </Grid>
      </>
    );
  };

  const renderDonate = () => {
    const secMsg = (
      <h5
        style={{
          textAlign: "center",
          fontWeight: 400,
          color: useTheme().palette.notes.main,
        }}>
        <Security />
        &nbsp;{sSecPay}
      </h5>
    );

    return showDonate === true ? (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "1rem",
          }}>
          <span className={classes.donateNum}>${donateAmount}&nbsp;</span>
          <Button
            color="info"
            size="lg"
            round
            onClick={() => setShowDonate(false)}>
            {sChgDonate}
          </Button>
        </div>
        {secMsg}
        {/* <PayPalButton
          amount={donateAmount}
          onSuccess={(data: any) => alert("Success")}
          onError={() => alert("Error")}
          onCancel={() => alert("Cancel")}
        /> */}
      </>
    ) : (
      <>
        {donateOptions()}
        <Button
          style={{
            display: "table",
            margin: "1rem auto",
            textTransform: "none",
          }}
          color="info"
          round
          size="lg"
          disabled={!donateAmount || donateAmount < 1}
          onClick={() => setShowDonate(true)}>
          DONATE - <i>Powered by PayPal</i>
        </Button>
        {secMsg}
      </>
    );
  };

  const renderSupportUs = (
    <>
      <div className={classes.title}>{sSupportUs}</div>
      <h5>{sSupUs1}</h5>
      <Divider />
      {showDonate === false && (
        <>
          <h5>{sSupUs2}</h5>
          <div className={classes.btnCenter}>
            {buttonYT(false)}
            {buttonFeedback(false, history, btnIconStyle)}
            {buttonShare()}
          </div>
        </>
      )}
      {/* {renderDonate()} */}
    </>
  );

  return (
    <div className={classes.pageBackground}>
      {page === "surv" ? (
        <SurveyDialog onClose={history.goBack} />
      ) : (
        <>
          {backButton(history)}
          <div className={classes.container}>
            <div className={classes.contentBox}>{renderSupportUs}</div>
          </div>
          {renderSharePopover(`https://apricad.com`, anchorEl, (e) =>
            handleShare(e, false),
          )}
        </>
      )}
    </div>
  );
};

const base: any = SupportUsPageBase;
export const SupportUsPage: any = { component: withStyles(styles)(base) };

export const buttonFeedback = (
  alwaysLarge: boolean,
  history: any,
  style: object,
) => {
  const icon = <i className="far fa-comment-alt" style={style}></i>;
  const btn = (
    <Button
      id={idSurvTake}
      color="primary"
      round
      size="lg"
      onClick={() => history.push("/sup/surv")}>
      {icon}
      &nbsp;{sGiveFeedback}
    </Button>
  );

  return alwaysLarge ? (
    btn
  ) : (
    <div style={{ margin: "0 1rem" }}>
      <Hidden xsDown>{btn}</Hidden>
      <Hidden smUp>
        <Fab
          id={idSurvTake}
          color="primary"
          onClick={() => history.push("/sup/surv")}>
          {icon}
        </Fab>
      </Hidden>
    </div>
  );
};
